module.exports = __webpack_public_path__ + "img/Media-Facebook.4b74d96f.svg";